import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";
import type { ILoaderData } from "@/pages/panelPages/myFamily/addNewFamilyMember/addNewFamilyMember";
import type { IRole } from "@/interfaces";

const permissions: IRole[] = [
  "patient",
  "staff",
  "admin",
  "local-admin",
  "super-admin",
];

export const myFamilyRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.myFamily.route,
      lazy: () => import("@pages/panelPages/myFamily/myFamily"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.myFamily", [], "index", "main");
        return {};
      },
    },
    permissions: ["patient"],
  },
  {
    route: {
      path: path.familyMemberView.route,
      lazy: () =>
        import(
          "@pages/panelPages/myFamily/addNewFamilyMember/addNewFamilyMember"
        ),
      loader: ({ params, request }): ILoaderData => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.view-family-member",
            [{ title: "pageTitle.myFamily", url: path.myFamily.link() }],
            "view",
          );
        return { mode: "view", id: params.id! };
      },
    },
    permissions,
  },
  {
    route: {
      path: path.familyMemberEdit.route,
      lazy: () =>
        import(
          "@pages/panelPages/myFamily/addNewFamilyMember/addNewFamilyMember"
        ),
      loader: ({ params, request }): ILoaderData => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.edit-family-member",
            [{ title: "pageTitle.myFamily", url: path.myFamily.link() }],
            "edit",
          );
        return { mode: "edit", id: params.id! };
      },
    },
    permissions,
  },
  {
    route: {
      path: path.familyMemberCreate.route,
      lazy: () =>
        import(
          "@pages/panelPages/myFamily/addNewFamilyMember/addNewFamilyMember"
        ),
      loader: ({ request }): ILoaderData => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.addNewFamilyMember",
            [{ title: "pageTitle.myFamily", url: path.myFamily.link() }],
            "create",
          );
        return { mode: "create" };
      },
    },
    permissions: ["patient"],
  },
];
